module.exports = __webpack_public_path__ + "img/r-1-actbtn.bfc9811b.png";